import urlFilter from "../filters/url.filter";
import currencyFilter from "../filters/currency.filter";

/**
 * Данные по валютному типу вклада
 */
export class DepositCurrencyTypeData {
  /**
   * Валюта вклада.
   */
  public currency: string = "";

  /**
   * Срок вклада.
   */
  public term: string = '';

  /**
   * Вид вклада.
   */
  public type: string = '';

  /**
   * Мин сумма вклада.
   */
  public minSum: number | string = 0;

  /**
   * Макс сумма вклада.
   */
  public maxSum: number | string = 0;

  /**
   * Процент вклада
   */
  public rate: number = 0;

  /**
   * Картинка вклада
   */
  public productImage: string = '';

  /**
   * Пополнение вклада
   */
  public depReplenishment: string = "";

  /**
   * Расходные операции
   */
  public expOperations: string = "";

  /**
   * Порядок выплаты процентов по вкладу
   */
  public interestPayProc: string = "";

  /**
   * Условия досрочного расторжения вклада
   */
  public earlyReturnRate: string = "";

  /**
   * Досрочное расторжение
   */
  public isEarlyDissolution: boolean = false;

  public earlyDissolution: string = '';

  /**
   * Расходные операции
   */
  public isExpOperations: boolean = false;

  /**
   * Пополнение
   */
  public isReplenishment: boolean = false;

  public informationExchange: string = '';

  public otherConditions: string = '';

  public extendingTerm: string = '';

  public operId: string = '';

  public initData: any = null;

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null, initData: any = null) {
    if (src) {
      this.currency = currencyFilter(src.currency) ?? "";
      this.type = src.type ?? "";
      this.term = src.term && src.term.length ? src.term : 'До востребования';
      const minSum = parseFloat(src.minSum);
      this.minSum = src.minSum && src.minSum.length && !isNaN(minSum)? parseFloat(src.minSum) : src.minSum;

      const maxSum = parseFloat(src.maxSum);
      this.maxSum = src.maxSum && src.maxSum.length && !isNaN(maxSum)? parseFloat(src.maxSum) : src.maxSum;

      this.rate = parseFloat(src.rate) ?? 0;
      this.productImage = urlFilter(src.productImage) ?? "";
      this.depReplenishment = src.depReplenishment ?? "";
      this.expOperations = src.expOperations ?? "";
      this.interestPayProc = src.interestPayProc ?? "";
      this.earlyReturnRate = src.earlyReturnRate ?? "";
      this.isEarlyDissolution = src.isEarlyDissolution ?? false;
      this.earlyDissolution = src.earlyDissolution ?? "";
      this.isExpOperations = src.isExpOperations ?? false;
      this.isReplenishment = src.isReplenishment ?? false;
      this.informationExchange = src.informationExchange ?? "";
      this.otherConditions = src.otherConditions ?? "";
      this.extendingTerm = src.extendingTerm ?? "";
      this.operId = src.operId ?? "";
    }
    if (initData) {
      this.initData = initData;
    }
  }
}
